import React, { lazy, Suspense } from 'react';
import {connect} from "react-redux";

import HeaderTop from '../../../app/components/component.header_top';
import Header from '../../../app/components/component.header';
import Footer from '../../../app/components/component.footer';
import Loader from "../../../app/components/component.loader";
import {CONFIG} from "../../../app/config";

const AdminBar = lazy(() => import("./component.admin-bar"));
const DevPanel = lazy(() => import("../dev/component.dev-panel"));
const Preview = lazy(() => import("./component.preview"));

const ComponentCookie = lazy(() => import("./component.cookie"));

const Page = lazy(() => import("./component.page"));

const isProduction = process.env.NODE_ENV == 'production';

const Main = (props) => {

    return <main>
        <a href="#content" className="skip-link">Till innehåll på sidan</a>
        <HeaderTop/>
        <Header/>
        {props.pageState.page &&
            <Suspense fallback={<Loader/>}>
                <Page/>
            </Suspense>}
        {!props.pageState.page && <Loader/>}
        <Footer/>
        {props.authState.data &&
            <Suspense fallback={<span>Loading...</span>}>
                <AdminBar/>
                <Preview/>
            </Suspense>}
        {!isProduction &&
            <Suspense fallback={<span>Loading...</span>}>
                <DevPanel/>
            </Suspense>}
        {CONFIG.components?.cookie_bar &&
            <Suspense fallback={<span>Loading...</span>}>
                <ComponentCookie {...CONFIG.components.cookie_bar} />
            </Suspense>}
    </main>
};

export default connect(state => {
    return {
        authState: state.authState,
        pageState: state.pageState,
        customState: state.customState
    }
})(Main);
